import { NgModule } from '@angular/core';
import { SummaryComponent } from './summary.component';
import { HeaderModule } from 'src/app/controls/header/header.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [SummaryComponent],
    imports: [HeaderModule, CommonModule, FormsModule],
    exports: [SummaryComponent],
    providers: [],
    bootstrap: [SummaryComponent]
})
export class SummaryModule { }